import { Sparkles, Clock, ShoppingCart, ListChecks } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const Benefits = () => {
  const benefits = [
    {
      icon: Sparkles,
      title: "Zero comida repetida",
      description: "30 receitas pensadas para você não cair na mesmice. Cada dia uma opção diferente e saborosa.",
    },
    {
      icon: Clock,
      title: "Pronto em até 30 minutos",
      description: "Ideal para quem tem pressa no almoço. Receitas testadas e cronometradas para caber na sua rotina.",
    },
    {
      icon: ShoppingCart,
      title: "Ingredientes do dia a dia",
      description: "Nada caro ou difícil de achar. Use o que você já tem em casa ou encontra em qualquer mercado.",
    },
    {
      icon: ListChecks,
      title: "Lista de compras única",
      description: "Planeje o mês de uma vez, sem desperdício. Economize tempo e dinheiro com organização inteligente.",
    },
  ];

  return (
    <section id="por-que" className="py-16 lg:py-24 bg-background">
      <div className="container">
        <div className="text-center mb-12 animate-fade-in">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-4">
            Por que isso muda sua rotina na cozinha
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Variedade, praticidade e economia em um só lugar
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <Card 
                key={index}
                className="border-2 hover:border-primary/50 transition-all duration-300 hover:shadow-soft animate-slide-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <CardContent className="pt-6">
                  <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-gradient-warm">
                    <Icon className="h-6 w-6 text-white" />
                  </div>
                  <h3 className="mb-2 text-xl font-bold">{benefit.title}</h3>
                  <p className="text-muted-foreground">{benefit.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
